
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Build from 'plaid-threads/Icons/Build';
import Key from 'plaid-threads/Icons/Key';
import Mobile from 'plaid-threads/Icons/Mobile';
import Rocket from 'plaid-threads/Icons/Rocket';
import Sandbox from 'plaid-threads/Icons/Sandbox';
import Transfer from 'plaid-threads/Icons/Transfer';
import Actions from '../../../../components/docs/Actions';
import DefinitionTable from '../../../../components/docs/DefinitionTable';
import TokenExchangeFlow from '../../../../components/docs/plaidoms/TokenExchangeFlow';
import Layout from '../../../../components/docs/Layout';
import Video from '../../../../components/accelerate/Video';
export const metadata = {
  noIndex: true,
  title: 'Bootcamp workshops',
  section: 'Accelerate',
  toc: false,
  description: 'Resources from three days of workshops.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Header title='Bootcamp workshops' subtitle='Resources from three days of workshops.' mdxType="Header" />
    <p>{`Your journey with Accelerate will begin with our 3-day bootcamp, a series of workshops on 9 distinct topics that have been identified to address your current pain points and are most relevant to companies at your stage. These interactive workshops will be led by subject matter experts at Plaid, who continuously help Plaid grow in these domains.`}</p>
    <p>{`Below is a detailed breakdown of the bootcamp, the workshops and related material for you to read through during the course of the Accelerate program.`}</p>
    <Layout.Spacer units={4} />
    <h4 {...{
      "id": "pre-bootcamp-survey"
    }}>{`Pre-bootcamp survey`}</h4>
    <p>{`To make sure the workshops and its content is tailored to address some of your current pain points, we will be sending a pre-bootcamp survey. Designed by the workshop leads, this survey will include questions specific to each workshop to help the workshop leads better understand your current challenges, identify patterns and address as many of them during the course of the bootcamp.`}</p>
    <p><a parentName="p" {...{
        "href": "https://forms.gle/yhHV1yfQy3th5D5v5"
      }}>{`Take the pre-bootcamp survey`}</a></p>
    <Layout.Spacer units={4} />
    <h4 {...{
      "id": "workshop-schedule"
    }}>{`Workshop schedule`}</h4>
    <p>{`For 3 days starting April 13, 2021, the bootcamp will consist of 9 workshops, covering a wide range of topics as seen in the schedule below.`}</p>
    <p>{`Each workshop will be 60-90 minutes long and is designed to be interactive. The content for all of this workshop content will be tailored based on the pre-bootcamp survey and provide a holistic overview of the topic as will be beneficial for companies at your stage. To make the most of the bootcamp experience, we encourage you to come prepared and be active participants during the workshop.`}</p>
    <p><a parentName="p" {...{
        "href": "https://calendar.google.com/calendar/u/0?cid=Y18wcmRhNW9mY2IzdjBzN2FobGhoMDZodDdjZ0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t"
      }}>{`Add the schedule to your calendar`}</a></p>
    <Layout.Spacer units={2} />
    <Image src='/assets/img/accelerate/2021/bootcamp-schedule-2021.png' alt='2021 Accelerate Bootcamp Workshop Schedule' isLazy={false} mdxType="Image" />
    <Layout.Spacer units={5} />
    <h3 {...{
      "id": "workshops"
    }}>{`Workshops`}</h3>
    <p>{`Here is an overview of the 9 topics we have identified to be a part of the bootcamp. If you do not see a topic that you might be interested in, please reach out to `}<inlineCode parentName="p">{`finrise@plaid.com`}</inlineCode></p>
    <p>{`We understand that there is a lot of material that will get covered during these three days of workshops, so links to all workshop materials, including slide decks, recordings of presentations and workshop activity/reference material will be made available here so as to help you implement and check the content at your own time, after the bootcamp.`}</p>
    <Layout.Spacer units={3} />
    <Layout.SideBySide>
      <p>{`{' '}`}</p>
      <div>
  <h4>Managing finances</h4>
  <h6>EVELYN CHAN, MATT MATERA, & SHENAE SIMMONS</h6>
  <p>
    While dealing with budgets and accounting might seem onerous and time
    consuming, it is often the most important and foundational aspect of how
    effectively your startup functions.
  </p>
  <p>
    Often, providing best practices on how to distil your financial focus into a
    few key areas, including how to maximize the efficiency of your capital and
    avoid financial pitfalls can come in handy.
  </p>
  <p>
    In this workshop, we will cover accounting 101 for startups, budgeting,
    pricing, billing & invoicing, and working with external auditors.
  </p>
      </div>
      <div>{/* <Video.Embed /> */}</div>
      <p>{`{/`}<em parentName="p">{` `}<Video.Embed title='Workshop recording' src='https://drive.google.com/file/d/1nnucwvXHTelwvMJA7LDfJiubqXyO3cC2/preview' />{` `}</em>{`/}`}</p>
    </Layout.SideBySide>
    <Layout.Spacer units={4} />
    <Layout.SideBySide>
  <div>
    <h4>Getting started with information security</h4>
    <h6>Shano Fonseka, Kyle Barry & Nitin Chauhan</h6>
    <p>
      For early-stage companies, the idea of protecting the business against
      downside risk can be awkward. This is the case because, as an early-stage
      company, the majority of your resources will be allocated up to maximize
      the upside from a product and GTM perspective. However, as your business
      grows, understanding and mitigating against downside risks, such as
      preventing a data security breach, will need to move up in your hierarchy
      of organizational needs.
    </p>
    <p>
      In this workshop, we will cover some strategies for navigating these
      decisions, and more specifically, how to identify and manage information
      security risks for your growing business.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={2} />
    <Layout.SideBySide>
  <div>
    <h4>Navigating the regulatory landscape</h4>
    <h6>Katie Neal</h6>
    <p>
      Financial regulation is an incredibly dense and convoluted field to
      navigate. On top of federal financial regulation, there are fifty
      different states with webs of laws. Additionally, regulator and
      policymaker interest in the intersection of financial technology has
      picked up drastically over the last year. Relevant laws, such as consumer
      privacy, data retention, and opt-out requirements add another layer of
      complexity to this ecosystem.
    </p>
    <p>
      This workshop aims to help lay out the current policy landscape, help
      founders develop an engagement strategy with relevant federal and state
      regulators and lawmakers, and avoid some of the pitfalls that can limit
      innovative new consumer use cases.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={2} />
    <Layout.SideBySide>
  <div>
    <h4>Building a tech infrastructure</h4>
    <h6>SHENAE SIMMONS & MARK ROBINSON</h6>
    <p>
      For many startups, the challenge of balancing over- and under-investment
      in their technical stack has a huge impact on their product development
      lifecycle.
    </p>
    <p>
      In this workshop, we will help identify the right level of investment in
      product stack for founders and cover what investments can be deferred,
      what is actually very important to build brand trust, and how to optimize
      for, both, time and money.
    </p>
    <p>
      Our goal is to provide guidance to founders on how best to invest in their
      technical product to facilitate velocity and iterate quickly, while
      building a quality product.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={2} />
    <Layout.SideBySide>
  <div>
    <h4>Storytelling & building a narrative</h4>
    <h6>FREYA PETERSEN & CLAUDIO LO</h6>
    <p>
      How do you break through the noise and create a company narrative that
      inspires? As the media landscape evolves, securing press coverage as a
      fledgling company is increasingly challenging. And yet, creating awareness
      and attracting a following are pivotal for any company’s growth
      trajectory.
    </p>
    <p>
      In this session, we’ll provide guidance on how to develop your brand
      story, and ways in which you can approach translating that story across
      channels and audiences. After this session, you’ll be equipped with a
      story framework that can help form your identity and mission as a company.
      We’ll also offer guidance on how to approach the press and conference
      organizers in order to join relevant industry conversations and news
      cycles.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={4} />
    <Layout.SideBySide>
  <div>
    <h4>Designing user centric products & brand</h4>
    <h6>OLIVIA LUO, VICTORIA CAO & BHARGAVI KAMAKSHIVALLI</h6>
    <p>
      In a crowded FinTech market, building a product that addresses user needs
      and cultivating a reputable brand identity are both integral to a
      company’s success.
    </p>
    <p>
      In this session, we will share best practices for building empathy for
      your users and identifying key aspects to address within your
      product/service. We will also provide hands-on tools for you to understand
      how to improve the end-to-end user experience throughout their engagement
      with your product/service.
    </p>
    <p>
      Design is a discipline that touches many parts of a business. We hope you
      come away from this session with a better understanding around how to
      identify user pain points, build a holistic user journey that results in a
      trustworthy user experience, and utilize design to help influence your
      brand’s perception.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={4} />
    <Layout.SideBySide>
  <div>
    <h4>Investor readiness</h4>
    <h6>BRUNO WERNECK DE ALMEIDA & JOSEPH FERRER</h6>
    <p>
      One of the primary sources of underrepresentation in tech is unequal
      access to capital and finding the right partners to grow your business
      with is crucial
    </p>
    <p>
      In this workshop, we will outline best practices around tying key
      indicators to fundraising milestones, identifying ideal investors and
      sequencing outreaching, managing the capital raise process, and post-raise
      investor communications.
    </p>
    <p>
      After the workshop, we hope you will be able to structure a streamlined
      fundraise process and understand when your business is ready for each
      stage of company building. With the wide range of investor types and
      stages, it can be challenging to identify and engage with the right
      capital partners but doing so can help accelerate your business and
      position for long-term success.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={4} />
    <Layout.SideBySide>
  <div>
    <h4>Hiring & building teams</h4>
    <h6>MARYNA SIVAIEVA & CHRIS AHSING</h6>
    <p>
      For early stage companies setting up best recruiting practices is the most
      important and hardest part of building a company. Recruiting strategy is a
      crucial advisory function that a company needs in order to succeed. When
      recruiting is reactionary it can have detrimental long term effects on
      company growth and culture.
    </p>
    <p>
      Our goal through this workshop is to educate members of founding teams on
      how to conduct thoughtful recruiting that will help you identify, hire,
      and keep suitable talent. We will help participants optimize recruiting
      coast, quality, and speed.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={4} />
    <Layout.SideBySide>
  <div>
    <h4>Ongoing support</h4>
    <h6>Nell Malone</h6>
    <p>
      In this workshop we will be going through the partnership structure for
      the next nine months. We will provide details around the ongoing
      skillshare network to support any questions you may have during the
      program period, the mentorship network to get you specialized advice based
      on the needs of your startup and the account management support you will
      receive for your Plaid integration.
    </p>
  </div>
  <div>{/* <Video.Embed /> */}</div>
    </Layout.SideBySide>
    <Layout.Spacer units={5} />
    <h3 {...{
      "id": "post-bootcamp-support"
    }}>{`Post-bootcamp support`}</h3>
    <p>{`Workshop leads will do their best to address all of your suggestions during the workshop, but please be aware that the content will be optimized to be holistic and beneficial to all participants. If your specific question does not get answered during the workshop or if you have tactical questions coming out of the bootcamp, feel free to reach out to the skill share network. Read more about this in the `}<a parentName="p" {...{
        "href": "/accelerate/2021/ongoing-support"
      }}>{`ongoing support network`}</a>{` section of this guide.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "pre-bootcamp-survey",
        level: 4,
        title: "Pre-bootcamp survey",
      },
{
        id: "workshop-schedule",
        level: 4,
        title: "Workshop schedule",
      },
{
        id: "workshops",
        level: 3,
        title: "Workshops",
      },
{
        id: "post-bootcamp-support",
        level: 3,
        title: "Post-bootcamp support",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
